import { DualPrice, Price, SinglePrice, formatPrice } from 'modules/proposals';
import React from 'react';

interface Props {
  currency: string;
  totalAmount: number;
  exchangeRate?: number;
  dualCurrency?: string;
  ISOCountry?: string;
}

export const TotalSegmentPrice: React.FC<Props> = ({
  currency,
  totalAmount,
  exchangeRate,
  dualCurrency = 'eur',
  ISOCountry,
}) => (
  <Price
    currency={currency}
    dualCurrency={dualCurrency}
    customExchangeRate={exchangeRate}
    dualPriceElement={
      <DualPrice className="segment-prices__price">
        <p className="t-eta">
          {formatPrice(totalAmount, currency, ISOCountry)}
        </p>
        {exchangeRate && (
          <p className="o-60 text--xxs__responsive">
            {formatPrice(totalAmount * exchangeRate, dualCurrency, ISOCountry)}
          </p>
        )}
      </DualPrice>
    }
    singlePriceElement={
      <SinglePrice className="t-eta">
        {formatPrice(totalAmount, currency, ISOCountry)}
      </SinglePrice>
    }
  />
);
